var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToastError = function SvgToastError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 14.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#toast-error_svg__a)",
    d: "M9.54 14.4H6.46c-3.704 0-5.556 0-6.239-1.205s.265-2.802 2.16-5.996l1.54-2.596C5.74 1.534 6.65 0 8 0c1.35 0 2.26 1.534 4.08 4.603l1.54 2.596c1.894 3.194 2.842 4.791 2.159 5.996S13.244 14.4 9.539 14.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#991B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 11.2V8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA5A5",
    d: "M8 4.8a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#991B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 5h.1m.1 0a.2.2 0 1 0-.4 0 .2.2 0 0 0 .4 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "toast-error_svg__a",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 14.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F87171"
  })))));
};
export default SvgToastError;